import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";

import logo from "../../icons/myIcons/logo.png";
import logo2 from "../../icons/myIcons/myloginImg.png";
import bg6 from "../../images/background/bg6.jpg";
import Select from "react-select";
import { loginApi } from "../../service/bankApi/login";
import {
  authenticate,
  setLoading,
  setUserDetails,
} from "../../feature/authSlice";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InputField from "../components/Fields/inputFields";
import { Button, Modal, Nav, Tab } from "react-bootstrap";
import {
  emailValidation,
  passwordValidation,
  phoneOnChange,
  phoneValidation,
} from "../../function/validation";
import PrimaryButton from "../components/Fields/primaryButton";
import Slider from "../components/swiper/swiper";
import { resendOtpApi } from "../../service/auth/resendPassword";
import PasswordField from "../components/Fields/passwordField";
import OtpModal from "../components/OtpModal/OtpModal";
import { getPermissions } from "../../service/auth/permissionsApi";
import { setPermissions } from "../../feature/permissions";
import ReCAPTCHA from "react-google-recaptcha";
import { jwtDecode } from 'jwt-decode';
import {EncKeys} from "../../service/config"
import * as CryptoJS from "crypto-js";
import { encryptStringBase64 } from "../../service/cryptohelpers";

import { ref, set } from "firebase/database";
import { db } from "../../service/firebase";

// Function to write to Firebase
const writeSessionToFirebase = async (userId, securityStamp) => {
  try {
    const sessionRef = ref(db, `ConcurrentSessionCheck/${userId}`);
    await set(sessionRef, {
      UserId: userId,
      SecurityStamp: securityStamp,
      LoginTime: Date.now(),
    });
    // console.log("✅ Session written to Firebase");
  } catch (error) {
    console.error("❌ Failed to write session:", error);
  }
};


function Login(props) {
  const dispatch = useDispatch();

  const [selectedOption, setSelectedOption] = useState({
    value: "chocolate",
    label: "FMS",
  });

  const getInvoiceByEmailData = useSelector((state) => state.getInvoiceByEmail);

  const notifyTopRight = (e, s) => {
    if (s == "s") {
      toast.success(e, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      toast.error(e, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const options = [
    { value: "chocolate", label: "FMS" },
    { value: "strawberry", label: "Bill to pay" },
  ];

  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  let errorsObj = { email: "", password: "" };
  const [errors, setErrors] = useState(errorsObj);
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [loadingActive, setLoadingActive] = useState(false);
  const [messageErrorStatus, setMessageErrorStatus] = useState(false);
  const [otp, setOtp] = useState("");
  const [tabOpen, setTabOpen] = useState(1);
  const [otpModal, setOtpModal] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [userId, setUserId] = useState("");
  const [timer, setTimer] = useState(60); // 60 seconds countdown
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [recaptchaValue,setRecaptchaValue]=useState('')
  const recaptchaRef = useRef()
  const resetCaptcha = async (event) => {
    if (recaptchaRef.current) {
        // Reset the reCAPTCHA
        recaptchaRef.current.reset()
    }
}

const handleRecaptchaChange = (value) => {
  setRecaptchaValue(value)
}

  useEffect(() => {
    if (getInvoiceByEmailData && getInvoiceByEmailData.authorized) {
      // console.log("Invoice Data : " + JSON.stringify(getInvoiceByEmailData));
      setTabOpen(2);
      setPhone(getInvoiceByEmailData.mobileNumber);
      if (phone) {
        onLogin();
      }
    }
  }, [getInvoiceByEmailData, phone]);

  useEffect(() => {
    let interval = null;
    if (isResendDisabled && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setIsResendDisabled(false);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isResendDisabled, timer]);
  function validateEntry(e) {
    e.preventDefault();
    if (tabOpen == 1) {
      if (!emailValidation(email)) {
        if (!emailValidation(email)) {
          setEmailError(true);
        }
      } else {
        onLogin();
      }
    } else if (tabOpen == 2) {
      if (!phoneValidation(phone)) {
        setPhoneError(true);
        return;
      } else {
        onLogin();
      }
    }
  }
const onLogin = async (e) => {

    var data = {
      code: "",
      email: tabOpen == 2 ? phone : email,
      password: password,
      code: otp,
      recaptchaValue:recaptchaValue
    };
    // console.log(recaptchaRef)
if(!recaptchaValue){
  toast.error("Captcha is required")
  return;
}
setLoadingActive(true);

    try {
      dispatch(
        loginApi(
          data, 
       async (responseData) => {
 resetCaptcha()
 setRecaptchaValue('')
                      setLoadingActive(false);
            if (responseData?.data?.result?.IsPasswordExpired) {
              setTimeout(() => {
                toast.error("Your password has expired, please set a new password")
              }, 100);
              localStorage.setItem("user_id", responseData.data.result.UserId);
              navigate("/changePassword");
            } else {
              if (responseData.data.result.Token_chr == null) {
                setUserId(responseData.data.result.UserId);
                setOtpModal(true);
              } else {
                if (responseData?.data?.result?.LastLoginTime === null) {
                  localStorage.setItem(
                    "user_id",
                    responseData.data.result.UserId
                  );
                  navigate("/changePassword");
                } else {
                            let decodedToken = jwtDecode(responseData.data.result.Token_chr);
          // console.log(decodedToken)
// Check token expiration
const currentTime = Date.now() / 1000; // Convert to seconds
if (decodedToken.exp < currentTime) {
  localStorage.clear();
  toast.error('Session expired. Please login again.', 'error');
  navigate('/login');
  return;
}
//new code
// Extract data from decoded token claims
const userId = decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid"];
// const email = decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
const firstName = decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname"];
const lastName = decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname"];
// const phoneNumber = decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/mobilephone"];
const customerId = decodedToken["CustomerId"];
const pustomerId = decodedToken["PropertyId"];
const permissionArr = decodedToken["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];

// Reconstruct user object from token claims
const userFromToken = {
  userId: userId,
  FirstName: firstName,
  Roles: Array.isArray(permissionArr) ? permissionArr : [permissionArr],
  CustomerId: customerId,
  PropertyId: pustomerId
};
                  dispatch(setUserDetails(userFromToken));
const encKey = CryptoJS.enc.Utf8.parse(EncKeys.VayanaEncKey);
const iv = CryptoJS.enc.Utf8.parse(EncKeys.IV);
const token = responseData.data.result.Token_chr;
const jsonString = JSON.stringify({ token });
const encrypted = CryptoJS.AES.encrypt(
  CryptoJS.enc.Utf8.parse(jsonString),
  encKey,
  {
    keySize: 128 / 8,
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }
).toString();
const security_stamp =responseData.data.result.SecurityStamp;
const encryptedSecurityStamp = CryptoJS.AES.encrypt(
  CryptoJS.enc.Utf8.parse(security_stamp),
  encKey,
  {
    keySize: 128 / 8,
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }
).toString();
                  
                  localStorage.setItem(
                    "access_token",
                    encrypted
                  );
                  localStorage.setItem(
                    "security_stamp",
                    encryptedSecurityStamp
                  );

                  // NEW
await writeSessionToFirebase(
  userId,
  responseData.data.result.SecurityStamp // Plain text, not encrypted
);

                  dispatch(authenticate());
                  const payload = {
                    Roles: Array.isArray(permissionArr) ? permissionArr : [permissionArr],
                  };
                  dispatch(
                    getPermissions(payload, (res) => {
                      dispatch(setPermissions(res?.data?.result));

                      if (getInvoiceByEmailData.authorized) {
                        const dataToSend = {
                          Id: getInvoiceByEmailData.Id,
                          data: { Value: { CanApprove: true } },
                          tab: "Pending for Approval",
                        };
                        navigate("/verificationEditScreen", {
                          state: dataToSend,
                        });
                      } else {
                        if (
                          responseData.data.result.Roles[0].includes(
                            "CustomerChecker"
                          )
                        ) {
                          navigate("/invoiceList");
                        } else {
                          navigate("/dashboard");
                        }
                      }
                    })
                  );
                }
              }
            }
          },
          (err) => {
            setLoadingActive(false);
            resetCaptcha()
            setRecaptchaValue('')
            // if(otpModal ){
            //   notifyTopRight("Invalid Otp", "e")

            // }
            setMessageErrorStatus(true);
            setLoadingActive(false);
          }
        )
      );
    } catch (error) {}
  }  
  const submit = async(e)=> {

    var data = {
      code: "",
      email: tabOpen == 2 ? phone : email,
      password: password,
      code: otp,
      recaptchaValue:recaptchaValue
    };
    // console.log(recaptchaRef)
setLoadingActive(true);

    try {
      dispatch(
        loginApi(
          data, 
          async (responseData) =>  {

                                       let decodedToken = jwtDecode(responseData?.data?.result?.Token_chr);
          // console.log(decodedToken)
// Check token expiration
const currentTime = Date.now() / 1000; // Convert to seconds
if (decodedToken.exp < currentTime) {
  localStorage.clear();
  toast.error('Session expired. Please login again.', 'error');
  navigate('/login');
  return;
}
//new code
// Extract data from decoded token claims
const userId = decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid"];
// const email = decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
const firstName = decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname"];
const lastName = decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname"];
// const phoneNumber = decodedToken["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/mobilephone"];
const customerId = decodedToken["CustomerId"];
const pustomerId = decodedToken["PropertyId"];
const permissionArr = decodedToken["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];

// Reconstruct user object from token claims
const userFromToken = {
  UserId: userId,
  UserName: firstName+""+lastName,
  Roles: Array.isArray(permissionArr) ? permissionArr : [permissionArr],
  CustomerId: customerId,
  PropertyId: pustomerId
};

 resetCaptcha()
 setRecaptchaValue('')
                      setLoadingActive(false);
            if (responseData?.data?.result?.IsPasswordExpired) {
              setTimeout(() => {
                toast.error("Your password has expired, please set a new password")
              }, 100);
              localStorage.setItem("user_id", userId);
              navigate("/changePassword");
            } else {
              if (responseData.data.result.Token_chr == null) {
                setUserId(userId);
                setOtpModal(true);
              } else {
                if (responseData?.data?.result?.LastLoginTime === null) {
                  localStorage.setItem(
                    "user_id",
                   userId
                  );
                  navigate("/changePassword");
                } else {

 

                  dispatch(setUserDetails(userFromToken));
const encKey = CryptoJS.enc.Utf8.parse(EncKeys.VayanaEncKey);
const iv = CryptoJS.enc.Utf8.parse(EncKeys.IV);
const token = responseData.data.result.Token_chr;
const jsonString = JSON.stringify({ token });
const encrypted = CryptoJS.AES.encrypt(
  CryptoJS.enc.Utf8.parse(jsonString),
  encKey,
  {
    keySize: 128 / 8,
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }
).toString();
const security_stamp =responseData.data.result.SecurityStamp;
const encryptedSecurityStamp = CryptoJS.AES.encrypt(
  CryptoJS.enc.Utf8.parse(security_stamp),
  encKey,
  {
    keySize: 128 / 8,
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }
).toString();
                  localStorage.setItem(
                    "access_token",
                    encrypted
                  );
                  localStorage.setItem(
                    "security_stamp",
                    encryptedSecurityStamp
                  );
                                    // NEW
await writeSessionToFirebase(
  userId,
  responseData.data.result.SecurityStamp // Plain text, not encrypted
);

                  dispatch(authenticate());
                  const payload = {
                    Roles: Array.isArray(permissionArr) ? permissionArr : [permissionArr],
                  };
                  dispatch(
                    getPermissions(payload, (res) => {
                      dispatch(setPermissions(res?.data?.result));

                      if (getInvoiceByEmailData.authorized) {
                        const dataToSend = {
                          Id: getInvoiceByEmailData.Id,
                          data: { Value: { CanApprove: true } },
                          tab: "Pending for Approval",
                        };
                        navigate("/verificationEditScreen", {
                          state: dataToSend,
                        });
                      } else {
                        if (
                          responseData.data.result.Roles[0].includes(
                            "CustomerChecker"
                          )
                        ) {
                          navigate("/invoiceList");
                        } else {
                          navigate("/dashboard");
                        }
                      }
                    })
                  );
                }
              }
            }
          },
          (err) => {
            setLoadingActive(false);
            resetCaptcha()
            setRecaptchaValue('')
            // if(otpModal ){
            //   notifyTopRight("Invalid Otp", "e")

            // }
            setMessageErrorStatus(true);
            setLoadingActive(false);
          }
        )
      );
    } catch (error) {}
  }

  const handleChange = (element) => {
    setOtp(element);
  };

  function resendOtp() {
    setLoadingActive(true);
    var data = {
      UserId: userId,
      Module: "Login OTP",
      OTP: "",
    };
    try {
      dispatch(
        resendOtpApi(
          data,
          (res) => {
            setLoadingActive(false);
            setOtp("");
            setIsResendDisabled(true);
            setTimer(30);
            // Logic to resend OTP
            notifyTopRight("Otp resent successfully", "s");
          },
          () => {
            setOtp("");
            setIsResendDisabled(true);
            setTimer(30);
            setLoadingActive(false);
          }
        )
      );
    } catch (error) {
      setLoadingActive(false);
    }
    setLoadingActive(false);
    setOtp("");
  }

  return (
    <>
      <ToastContainer />
      <div className=" " style={{ background: "#f1f1ff" }}>
        <div
          className="col-xl-12 parent"
          // style={{
          //   height: "100dvh",
          //   display: "flex",
          //   // justifyContent: "center",
          //   flexDirection: "column",
          // }}
        >
          <div className="child border-0 d-flex justify-content-center">
            <div className=" card login-bx" style={{ width: "80%" }}>
              <div className="row custome-row">
                <div
                  className="col-xl-6 col-md-6  text-center d-flex justify-content-center align-items-center "
                  style={{ borderRight: "1px solid lightgray" }}
                >
                  {/* <img src={logo} alt="" style={{ width: '250px' }} /> */}
                  {/* <Slider /> */}
                  <div className="mb-0">
                            <div className="card-body pb-2 pt-3">
                                <div className="text-center pop-cousin">
                                    <img src={logo2} alt="" style={{height:'auto',width:'100%'}}/>
                                    <h4>
									Facility Management System – Streamline, Simplify, and Save !                                     </h4>
                                </div>
                            </div>
                        </div>
                </div>
                <div className="col-xl-6 col-md-6  d-flex cutome-col align-items-center justify-content-center overflow-auto">
                  <div className="sign-in-your mt-3 " style={{ width: "90%" }}>
                    <div className="row d-flex justify-content-center">
                      <img
                        src={logo}
                        style={{ width: "150px", cursor: "pointer" }}
                        alt=""
                      />
                    </div>
                    <div className="row mt-1">
                      <p
                        className="login-subtitle mt-3"
                        style={{ textAlign: "center" }}
                      >
                        {/* Process your invoices */}
                      </p>
                    </div>

                    <div className="row mt-4">
                      <span
                        className="login-title"
                        style={{ textAlign: "center", fontWeight: "600" }}
                      >
                        {tabOpen == 1 ? "Login with Email" : "Login with Phone"}
                      </span>
                    </div>

                    <form onSubmit={validateEntry}>
                      {tabOpen == 1 && (
                        <div className="row mt-4">
                          <InputField
                            labelName={"Email"}
                            onChange={(e) => {
                              setMessageErrorStatus(false);
                              errors.email = false;
                              setEmail(e.target.value);
                              setEmailError(false);
                            }}
                            value={email}
                            errorOccured={emailError}
                            errorMeesage={"Please enter valid email"}
                          />

                          <PasswordField
                            labelName={"Password"}
                            onChange={(e) => {
                              e.target.value = e.target.value.toString();
                              // .slice(0, 12)
                              setMessageErrorStatus(false);

                              errors.password = false;
                              setPassword(e.target.value);
                              setPasswordError(false);
                            }}
                            inputValue={password}
                            errorOccured={passwordError}
                            errorMeesage={"Please enter valid password "}
                          />
                        </div>
                      )}

                      {tabOpen == 2 && (
                        <div className="row mt-4">
                          <InputField
                            labelName={"Phone"}
                            onChange={(e) => {
                              if (phoneOnChange(e.target.value)) {
                                setPhone(e.target.value);
                                setPhoneError(false);
                              }
                            }}
                            value={phone}
                            errorOccured={phoneError}
                            errorMeesage={"Please enter valid phone"}
                          />
                        </div>
                      )}

                      <div className="form-group text-left d-flex justify-content-end mt-2">
                        <p
                          style={{ color: "#9568FF", cursor: "pointer" }}
                          onClick={() => {
                            navigate("/forgotPassword");
                          }}
                        >
                          Forgot Password ?
                        </p>
                      </div>
                      <div
                        style={{
                          maxWidth: "100%",
                          textAlign: "center",
                          marginBottom: "10px",
                        }}
                      >
                        <ReCAPTCHA
                          ref={recaptchaRef}
                          sitekey="6Lf_944oAAAAAJYchyqv-TJaDMmA1dcPwyQeVMXx" // Replace with your reCAPTCHA site key
                          onChange={handleRecaptchaChange}
                        />
                      </div>
                      <PrimaryButton
                        buttonName={"Login"}
                        type={"submit"}
                        isLoading={loadingActive}
                        loadingMessage={"Loading..."}
                        style={{
                          width: "100%",
                        }}
                      />
                    </form>
                    <PrimaryButton
                      buttonName={
                        tabOpen == 2 ? "Login with Email" : "Login with Mobile"
                      }
                      style={{
                        width: "100%",
                        background: "white",
                        color: "rgba(23, 90, 169, 0.78)",
                      }}
                      className={"mt-3"}
                      onClick={() => {
                        setPassword("");
                        if (tabOpen == 1) {
                          setTabOpen(2);
                        } else {
                          setTabOpen(1);
                        }
                      }}
                    />
                    <div className="row d-flex justify-content-center ">
                      {/* Apple Signin custom Button for login */}
                      <div className="col-12 d-flex justify-content-center">
                        <div className="buttoncover"></div>
                      </div>
                    </div>

                    <div className="row ">
                      <p style={{ textAlign: "center" }}>
                        By continuing, you agree to V2P<br></br>
                        <div className="">
                          <a
                            className="terms-condition-link"
                            href="https://www.vendortopay.com/Home/terms-and-conditions.html"
                            target="_blank"
                            rel="noreferrer"
                          >
                            {"Terms of Service "}
                          </a>
                          <span>and</span>
                          <a
                            href="https://vayana.com/privacy-policy/#:~:text=Vayana%20Network%20will%20not%20sell,the%20processing%20of%20the%20transaction"
                            className="terms-condition-link"
                            target="_blank"
                            rel="noreferrer"
                          >
                            {" Privacy Policy"}
                          </a>
                        </div>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {otpModal && (
          <OtpModal
            loadingActive={loadingActive}
            otpModal={otpModal}
            otp={otp}
            handleOtpChange={handleChange}
            handleModalClose={() => {
              setOtp("");
              setOtpModal(false);
            }}
            handleProceed={submit}
            resendOtp={resendOtp}
            recaptchaRef={recaptchaRef}
            handleRecaptchaChange={handleRecaptchaChange}
          />
        )}
      </div>
    </>
  );
}

export default Login;
